/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { reactSelectStyle } from "Config/Config";
import clipboardCopy from "clipboard-copy";

import { jwtDecode } from "jwt-decode";

import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";

import smtpSecureOptions from "data/Prod/smtpSecureOptions.json";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";

import {
  getData,
  uploadSingleFile,
  uploadMultipleFile,
  postData,
  putData,
} from "utils/Gateway";
import * as url from "helper/UrlHelper";

import {
  appUserHeaderLinks,
  appUserProfileLink,
} from "helper/AppUserHelper/AppUserHelper";
import { getPublicIP } from "helper/AuthHelper/AuthHelper";

import SaveSettingsSuccessModal from "./Modal/SaveSettingsSuccessModal";
import ConversationTestMailPopup from "components/Common/Popup/ConversationTestMailPopup";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";

const AppUserSettingsBody = () => {
  const todayValue = new Date().toISOString().split("T")[0];
  const { t } = useTranslation(); //for translation

  /* ---- bread crumb text ---- */
  const breadcrumbText = [
    { title: t("App User"), link: appUserProfileLink },
    { title: t("Settings") },
  ];

  const params = useParams();

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const commonHeaderObject = appUserHeaderLinks(params.id, t);

  const copyMessage =
    url.API_BASE_URL + url.API_LINKEDIN_HELPER + `/${userInfo._id}`;

  const [name, setName] = useState(userInfo.name || "");
  const [surName, setSurName] = useState(userInfo.surname || "");

  // Tab state
  const [activeTab, setActiveTab] = useState("mailSettings");

  // smtp config
  const [smtpHost, setSmtpHost] = useState(null);
  const [smtpUser, setSmtpUser] = useState(null);
  const [smtpPassword, setSmtpPassword] = useState(null);
  const [smtpPort, setSmtpPort] = useState(null);
  const [smtpSecure, setSmtpSecure] = useState(null);
  const [smtpSenderName, setSmtpSenderName] = useState(
    `${userInfo.name || ""} ${userInfo.surname || ""}`.trim() || null
  );
  const [useSmtpConfigValue, setUseSmtpConfigValue] = useState(false);
  const [useSmtpConfig, setUseSmtpConfig] = useState(null);

  // sendgrid config
  const [sendgridmail, setSendgridmail] = useState(null);
  const [sendgridkey, setSendgridkey] = useState(null);
  const [sendgridSenderName, setSendgridSenderName] = useState(
    `${userInfo.name || ""} ${userInfo.surname || ""}`.trim() || null
  );
  const [usesendgrid, setUsesendgrid] = useState(null);
  const [usesendgridSelectOption, setUsesendgridSelectOption] = useState(null);

  //out of field requirements
  const [telephone, setTelephone] = useState("");
  const [position, setPosition] = useState("");
  const [zipcode, setzipcode] = useState("");
  const [stateName, setstateName] = useState("");
  const [cityName, setcityName] = useState("");
  const [country, setcountry] = useState("");
  const [website, setWebsite] = useState("");
  const [rate, setRate] = useState("");
  const [address, setAddress] = useState("");
  const [cognifitToken, setCognifitToken] = useState("");

  const [isSaving, setisSaving] = useState(false);
  const [fbUser, setFbUser] = useState(null);

  // API Token tab
  const [apiToken, setApiToken] = useState("");
  const [isLoadingToken, setIsLoadingToken] = useState(false);

  // Security tab — active sessions
  const [sessions, setSessions] = useState([]);
  const [isLoadingSessions, setIsLoadingSessions] = useState(false);
  const [isLoggingOutAll, setIsLoggingOutAll] = useState(false);
  const location = useLocation();

  // Alert states
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const fbToken = urlParams.get("fbToken"); // Get fbToken from the query string

    if (fbToken) {
      try {
        const decoded = jwt_decode(fbToken);

        console.log("Decoded Facebook user:", decoded.profile); // Access the profile

        setFbUser(decoded.profile);

        // Store the token for later use (optional)
        localStorage.setItem("fbToken", fbToken);

        // Clean up the URL to remove the query parameters
        //window.history.replaceState({}, document.title, location.pathname);
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, [location]);

  //function for get user details
  const getUserDetails = async () => {
    const userPublicIp = await getPublicIP();

    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_DETAILS +
        `/${params.id}` +
        `?userip=${userPublicIp}`;

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status && response.data) {
        const data = response.data;

        setName(data.name || "");
        setSurName(data.surname || "");

        setTelephone(data.phone ?? "");
        setPosition(data.position ?? "");
        setAddress(data.address || "");
        setWebsite(data.website || "");
        setRate(data.costperhour || "");
        setstateName(data.state || "");
        setcityName(data.city || "");
        setcountry(data.country || "");
        setzipcode(data.zipcode || "");

        // mail configuration -----------------
        if (data.smtphost && data.smtphost.length > 0) {
          setSmtpHost(data.smtphost);
        }
        if (data.smtpuser && data.smtpuser.length > 0) {
          setSmtpUser(data.smtpuser);
        }
        if (data.smtppass && data.smtppass.length > 0) {
          setSmtpPassword(data.smtppass);
        }
        if (data.smtpport && data.smtpport.length > 0) {
          setSmtpPort(data.smtpport);
        }
        if (data.smtpsendername && data.smtpsendername.length > 0) {
          setSmtpSenderName(data.smtpsendername);
        } else {
          setSmtpSenderName(`${data.name || ""} ${data.surname || ""}`.trim());
        }

        if (data.sendgridmail && data.sendgridmail.length > 0) {
          setSendgridmail(data.sendgridmail);
        }

        if (data.sendgridkey && data.sendgridkey.length > 0) {
          setSendgridkey(data.sendgridkey);
        }

        if (data.sendgridsendername && data.sendgridsendername.length > 0) {
          setSendgridSenderName(data.sendgridsendername);
        } else {
          setSendgridSenderName(`${data.name || ""} ${data.surname || ""}`.trim());
        }

        if (data.cognifit_token && data.cognifit_token.length > 0) {
          setCognifitToken(data.cognifit_token);
        }

        for (let smtpSecureOption of smtpSecureOptions) {
          // set secure smtp connect option YES/NO
          if (smtpSecureOption.value == data.smtpsecure) {
            setSmtpSecure(smtpSecureOption);
          }

          // set either to use this config or not, YES / NO
          if (smtpSecureOption.value == data.usesmtpmail) {
            setUseSmtpConfig(smtpSecureOption);
            setUseSmtpConfigValue(smtpSecureOption.value);
          }

          // use sendgrid
          if (smtpSecureOption.value == data.usesendgrid) {
            setUsesendgridSelectOption(smtpSecureOption);
            setUsesendgrid(smtpSecureOption.value);
          }
        }

        // Ensure only one mail service can be active at a time
        // If both are true, prioritize SMTP
        if (data.usesmtpmail === true && data.usesendgrid === true) {
          const falseOption = smtpSecureOptions.find(opt => opt.value === false);
          setUsesendgridSelectOption(falseOption);
          setUsesendgrid(false);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // send a mail to check if config is validated
  const validateSmtpConfig = async () => {
    alert("send test mail and check connection");
  };

  const connectWithFacebook = () => {
    window.location.href = url.API_BASE_URL + "/auth/facebook";
  };

  const handleFacebookLogout = () => {
    setFbUser(null);
  };

  //function for save/update user
  const saveUserHandler = async () => {
    setisSaving(true);
    const userPublicIp = await getPublicIP();

    try {
      let userData = {
        position,
        phone: telephone,
        address,
        city: cityName,
        state: stateName,
        country,
        zipcode,
        costperhour: rate,
        website,

        smtphost: smtpHost && smtpHost.length > 2 ? smtpHost.trim() : null,
        smtpuser: smtpUser && smtpUser.length > 2 ? smtpUser.trim() : null,
        smtppass:
          smtpPassword && smtpPassword.length > 2 ? smtpPassword.trim() : null,
        smtpport: smtpPort && smtpPort.length > 1 ? smtpPort.trim() : null,
        smtpsecure: smtpSecure ? smtpSecure.value : null,
        smtpsendername:
          smtpSenderName && smtpSenderName.length > 2
            ? smtpSenderName.trim()
            : null,
        usesmtpmail: useSmtpConfig ? useSmtpConfig.value : null,

        sendgridmail:
          sendgridmail && sendgridmail.length > 2 ? sendgridmail.trim() : null,
        sendgridkey:
          sendgridkey && sendgridkey.length > 2 ? sendgridkey.trim() : null,
        sendgridsendername:
          sendgridSenderName && sendgridSenderName.length > 2
            ? sendgridSenderName.trim()
            : null,
        usesendgrid: usesendgridSelectOption
          ? usesendgridSelectOption.value
          : null,
        cognifit_token:
          cognifitToken && cognifitToken.length > 2
            ? cognifitToken.trim()
            : null,
      };

      let requestUrl = url.API_BASE_URL;

      let response = {};

      if (params.id) {
        requestUrl =
          requestUrl +
          url.API_UPDATE_APP_USER +
          `/${params.id}` +
          `?userip=${userPublicIp}`;
        response = await putData(requestUrl, userData);
      }

      console.log(response);

      setisSaving(false);

      if (response.status) {
        const bootstrapModal = new bootstrap.Modal(
          document.getElementById("saveSettingsModal")
        );
        bootstrapModal.show();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const getApiTokenHandler = async () => {
    setIsLoadingToken(true);
    try {
      const response = await getData(url.API_BASE_URL + url.API_GET_TOKEN);
      if (response.status) {
        setApiToken(response.token);
      }
    } catch (error) {
      console.log(error.message);
    }
    setIsLoadingToken(false);
  };

  const getSessionsHandler = async () => {
    setIsLoadingSessions(true);
    try {
      const response = await getData(url.API_BASE_URL + url.API_GET_SESSIONS);
      if (response.status) {
        setSessions(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
    setIsLoadingSessions(false);
  };

  const logoutAllHandler = async () => {
    setIsLoggingOutAll(true);
    try {
      const response = await postData(url.API_BASE_URL + url.API_LOGOUT_ALL);
      if (response.status) {
        localStorage.clear();
        window.location.href = "/";
      }
    } catch (error) {
      console.log(error.message);
    }
    setIsLoggingOutAll(false);
  };

  useEffect(() => {
    if (params.id) {
      getUserDetails();
    }
  }, [params.id]);

  useEffect(() => {
    if (activeTab === "security") {
      getSessionsHandler();
    }
    if (activeTab === "apiToken") {
      getApiTokenHandler();
    }
  }, [activeTab]);

  // Function for closing alert
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
  };

  return (
    <div id="content_wrapper">
      <section className="event-details-wrapper bg-white pb-5">
        {/* ---- expert details common header ---- */}
        {params.id && (
          <TabsHeader
            commonHeaderObject={commonHeaderObject}
            activeOption={t("Settings")}
          />
        )}

        <div className="container-fluid px-lg-5 pt-4 pt-md-0" style={{ paddingBottom: '100px' }}>
          {/* ---- bread crumb ------- */}
          <BreadCrumb
            breadCrumbText={breadcrumbText}
            bottom={true}
            displayName={`${name} ${surName}`}
          />

          {/* -------- table section ---------- */}

          {/* Tab Navigation */}
          <div className="mb-4 d-flex justify-content-between align-items-center">
            <ul className="nav nav-tabs flex-grow-1">
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "mailSettings" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("mailSettings")}
                  style={{
                    color: activeTab === "mailSettings" ? "#EE523C" : "#6c757d",
                    borderColor: activeTab === "mailSettings" ? "#EE523C" : "transparent",
                    fontWeight: activeTab === "mailSettings" ? "600" : "normal"
                  }}
                >
                  {t("Mail Settings")}
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "connectToApps" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("connectToApps")}
                  style={{
                    color: activeTab === "connectToApps" ? "#EE523C" : "#6c757d",
                    borderColor: activeTab === "connectToApps" ? "#EE523C" : "transparent",
                    fontWeight: activeTab === "connectToApps" ? "600" : "normal"
                  }}
                >
                  {t("Connect to Apps")}
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "apiToken" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("apiToken")}
                  style={{
                    color: activeTab === "apiToken" ? "#EE523C" : "#6c757d",
                    borderColor: activeTab === "apiToken" ? "#EE523C" : "transparent",
                    fontWeight: activeTab === "apiToken" ? "600" : "normal"
                  }}
                >
                  {t("API Token")}
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    activeTab === "security" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("security")}
                  style={{
                    color: activeTab === "security" ? "#EE523C" : "#6c757d",
                    borderColor: activeTab === "security" ? "#EE523C" : "transparent",
                    fontWeight: activeTab === "security" ? "600" : "normal"
                  }}
                >
                  {t("Security")}
                </button>
              </li>
            </ul>
            {/* Test Mail Button - Only show in Mail Settings tab */}
            {activeTab === "mailSettings" && (
              <button
                type="button"
                className="btn btn-outline-primary d-flex align-items-center gap-2 ms-3"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasTestMail"
                aria-controls="offcanvasTestMail"
              >
                <span className="material-symbols-outlined fs-5">mail</span>
                {t("Test Mail")}
              </button>
            )}
          </div>

          {/* Tab Content */}
          {activeTab === "mailSettings" && (
            <div className="tab-content-wrapper">
              {/* Show default platform SMTP message when both configs are disabled */}
              {!useSmtpConfigValue && !usesendgrid && (
                <div className="alert alert-info mb-4" role="alert">
                  <i className="bi bi-info-circle me-2"></i>
                  {t("Currently all mail of yours are sending using platform's default SMTP")}
                </div>
              )}

              <div 
                className="p-3 p-lg-4 border rounded-10 shadow-sm mb-4"
                style={{
                  borderColor: useSmtpConfigValue ? "#EE523C" : "#dee2e6",
                  borderWidth: useSmtpConfigValue ? "2px" : "1px"
                }}
              >
                {/* Mail sending configuration for this user ---------------------- */}
                <h3 style={{ color: useSmtpConfigValue ? "#EE523C" : "inherit" }}>
                  {t("SMTP Configuration (for sending mails)")}
                  {useSmtpConfigValue && (
                    <span className="badge bg-primary ms-2" style={{ backgroundColor: "#EE523C" }}>
                      {t("Active")}
                    </span>
                  )}
                </h3>

                <div className="form-group mb-3 mb-sm-4">
                  <div className="row align-items-center">
                    <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                      <p className="fs-md fw-semibold">{t("SMTP Host")}</p>
                    </div>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control fs-sm shadow-none border border-gray-300"
                        placeholder={t("SMTP Host")}
                        value={smtpHost}
                        onChange={(e) => setSmtpHost(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group mb-3 mb-sm-4">
                  <div className="row align-items-center">
                    <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                      <p className="fs-md fw-semibold">{t("SMTP User")}</p>
                    </div>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control fs-sm shadow-none border border-gray-300"
                        placeholder={t("SMTP User Email")}
                        value={smtpUser}
                        onChange={(e) => setSmtpUser(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group mb-3 mb-sm-4">
                  <div className="row align-items-center">
                    <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                      <p className="fs-md fw-semibold">{t("SMTP Password")}</p>
                    </div>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control fs-sm shadow-none border border-gray-300"
                        placeholder={t("SMTP Password")}
                        value={smtpPassword}
                        onChange={(e) => setSmtpPassword(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group mb-3 mb-sm-4">
                  <div className="row align-items-center">
                    <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                      <p className="fs-md fw-semibold">
                        {t("SMTP Port")} (
                        <i>{t("587 for non-SSL, 465 for SSL")}</i>)
                      </p>
                    </div>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control fs-sm shadow-none border border-gray-300"
                        placeholder={t("Set Port")}
                        value={smtpPort}
                        onChange={(e) => setSmtpPort(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group mb-3 mb-sm-4">
                  <div className="row align-items-center">
                    <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                      <p className="fs-md fw-semibold">{t("Sender Name")}</p>
                    </div>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control fs-sm shadow-none border border-gray-300"
                        placeholder={t("Sender Name")}
                        value={smtpSenderName}
                        onChange={(e) => setSmtpSenderName(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group mb-3 mb-sm-4">
                  <div className="row align-items-center">
                    <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                      <p className="fs-md fw-semibold">
                        {t("Is secure connection?")} (
                        <i>{t("true if SSL/TLS")}</i>)
                      </p>
                    </div>
                    <div className="col-lg-6">
                      <Select
                        options={smtpSecureOptions}
                        value={smtpSecure}
                        onChange={(val) => {
                          setSmtpSecure(val);
                        }}
                        styles={reactSelectStyle("3px", "6px", true, false)}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group mb-3 mb-sm-4">
                  <div className="row align-items-center">
                    <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                      <p className="fs-md fw-semibold">
                        {t("Use this configuration to send mails")}
                      </p>
                    </div>
                    <div className="col-lg-6">
                      <Select
                        options={smtpSecureOptions}
                        value={useSmtpConfig}
                        onChange={(val) => {
                          setUseSmtpConfig(val);
                          setUseSmtpConfigValue(val.value);
                          // If setting SMTP to true, disable SendGrid
                          if (val.value === true) {
                            const falseOption = smtpSecureOptions.find(opt => opt.value === false);
                            setUsesendgridSelectOption(falseOption);
                            setUsesendgrid(false);
                          }
                        }}
                        styles={reactSelectStyle("3px", "6px", true, false)}
                      />
                    </div>

                    {/* <div className="col-lg-2">
                      {useSmtpConfigValue == true ? (
                        <button
                          type="button"
                          className="btn btn-outline-success"
                          //onClick={validateSmtpConfig}
                        >
                          <span class="d-block material-symbols-outlined">
                            check
                          </span>
                        </button>
                      ) : (
                        ""
                      )}
                    </div> */}
                  </div>
                </div>

                {/* SEND GRID  ---------------------- */}
              </div>

              <div 
                className="p-3 p-lg-4 border rounded-10 shadow-sm"
                style={{
                  borderColor: usesendgrid ? "#EE523C" : "#dee2e6",
                  borderWidth: usesendgrid ? "2px" : "1px"
                }}
              >
                <h3 style={{ color: usesendgrid ? "#EE523C" : "inherit" }}>
                  {t("SendGrid Configuration (for sending mails)")}
                  {usesendgrid && (
                    <span className="badge bg-primary ms-2" style={{ backgroundColor: "#EE523C" }}>
                      {t("Active")}
                    </span>
                  )}
                </h3>

                <div className="form-group mb-3 mb-sm-4">
                  <div className="row align-items-center">
                    <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                      <p className="fs-md fw-semibold">SendGrid {t("Email")}</p>
                    </div>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control fs-sm shadow-none border border-gray-300"
                        placeholder={t("Email")}
                        value={sendgridmail}
                        onChange={(e) => setSendgridmail(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group mb-3 mb-sm-4">
                  <div className="row align-items-center">
                    <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                      <p className="fs-md fw-semibold">
                        {t("SendGrid API Key")}
                      </p>
                    </div>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control fs-sm shadow-none border border-gray-300"
                        placeholder={t("API Key")}
                        value={sendgridkey}
                        onChange={(e) => setSendgridkey(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group mb-3 mb-sm-4">
                  <div className="row align-items-center">
                    <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                      <p className="fs-md fw-semibold">{t("Sender Name")}</p>
                    </div>
                    <div className="col-lg-6">
                      <input
                        type="text"
                        className="form-control fs-sm shadow-none border border-gray-300"
                        placeholder={t("Sender Name")}
                        value={sendgridSenderName}
                        onChange={(e) => setSendgridSenderName(e.target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div className="form-group mb-3 mb-sm-4">
                  <div className="row align-items-center">
                    <div className="col-lg-6 mb-3 mb-sm-4 mb-lg-0">
                      <p className="fs-md fw-semibold">
                        {t("Use SendGrid for sending mail")}
                      </p>
                    </div>
                    <div className="col-lg-6">
                      <Select
                        options={smtpSecureOptions}
                        value={usesendgridSelectOption}
                        onChange={(val) => {
                          setUsesendgridSelectOption(val);
                          setUsesendgrid(val.value);
                          // If setting SendGrid to true, disable SMTP
                          if (val.value === true) {
                            const falseOption = smtpSecureOptions.find(opt => opt.value === false);
                            setUseSmtpConfig(falseOption);
                            setUseSmtpConfigValue(false);
                          }
                        }}
                        styles={reactSelectStyle("3px", "6px", true, false)}
                      />
                    </div>

                    {/* <div className="col-lg-2">
                      {usesendgrid == true ? (
                        <button
                          type="button"
                          className="btn btn-sm btn-success"
                          //onClick={validateSmtpConfig}
                        >
                          <span class="d-block material-symbols-outlined">
                            check
                          </span>
                        </button>
                      ) : (
                        ""
                      )}
                    </div> */}
                  </div>
                </div>

              </div>
            </div>
          )}

          {activeTab === "apiToken" && (
            <div className="tab-content-wrapper">
              <div className="p-3 p-lg-4 border border-gray-300 rounded-10 shadow-sm">
                <h3 className="mb-1">{t("API Access")}</h3>
                <p className="text-muted fs-sm mb-4">
                  {t("Use these credentials to connect external tools like Postman, N8N, Zapier, or any custom integration.")}
                </p>

                {/* Base URL */}
                <div className="form-group mb-4">
                  <label className="d-block fs-sm fw-semibold mb-2">
                    {t("API Base URL")}
                  </label>
                  <div className="d-flex align-items-center gap-2">
                    <input
                      type="text"
                      className="form-control border border-gray-300 rounded shadow-none fs-sm"
                      value={url.SERVER_URL}
                      readOnly
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary d-flex align-items-center gap-1"
                      title={t("Copy API Base URL")}
                      onClick={() => clipboardCopy(url.SERVER_URL)}
                    >
                      <span className="material-symbols-outlined icon-sm">content_copy</span>
                      {t("Copy")}
                    </button>
                  </div>
                </div>

                {/* Auth Token */}
                <div className="form-group mb-0">
                  <label className="d-block fs-sm fw-semibold mb-2">
                    {t("Your Auth Token")}
                  </label>
                  {isLoadingToken ? (
                    <div className="placeholder-glow">
                      <span className="placeholder col-12 rounded" style={{ height: "38px" }}></span>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="text"
                        className="form-control border border-gray-300 rounded shadow-none fs-sm"
                        value={apiToken}
                        readOnly
                        style={{ fontFamily: "monospace", fontSize: "0.75rem" }}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary d-flex align-items-center gap-1"
                        title={t("Copy Token")}
                        onClick={() => clipboardCopy(apiToken)}
                        disabled={!apiToken}
                      >
                        <span className="material-symbols-outlined icon-sm">content_copy</span>
                        {t("Copy")}
                      </button>
                    </div>
                  )}
                  <p className="text-muted fs-xs mt-2">
                    <span className="material-symbols-outlined icon-xs align-middle me-1">info</span>
                    {t("Pass this token in the")} <code>Authorization</code> {t("header as")} <code>Bearer &lt;token&gt;</code> {t("with every API request.")}
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === "security" && (
            <div className="tab-content-wrapper">
              <div className="p-3 p-lg-4 border border-gray-300 rounded-10 shadow-sm">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <h3 className="mb-1">{t("Active Sessions")}</h3>
                    <p className="text-muted fs-sm mb-0">
                      {t("These are all devices currently logged into your account.")}
                    </p>
                  </div>
                  <button
                    type="button"
                    className="btn btn-danger d-flex align-items-center gap-2"
                    onClick={logoutAllHandler}
                    disabled={isLoggingOutAll}
                  >
                    {isLoggingOutAll ? (
                      <>
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {t("Logging out...")}
                      </>
                    ) : (
                      <>
                        <span className="material-symbols-outlined icon-sm">logout</span>
                        {t("Logout from all devices")}
                      </>
                    )}
                  </button>
                </div>

                {isLoadingSessions ? (
                  <div className="d-flex flex-column gap-3">
                    {[1, 2, 3].map((i) => (
                      <div key={i} className="p-3 border border-gray-300 rounded-10 placeholder-glow">
                        <span className="placeholder col-4 mb-2 d-block"></span>
                        <span className="placeholder col-6 mb-1 d-block"></span>
                        <span className="placeholder col-3 d-block"></span>
                      </div>
                    ))}
                  </div>
                ) : sessions.length === 0 ? (
                  <div className="text-center py-5 text-muted">
                    <span className="material-symbols-outlined d-block mb-2" style={{ fontSize: "2rem" }}>devices</span>
                    {t("No active sessions found.")}
                  </div>
                ) : (
                  <div className="d-flex flex-column gap-3">
                    {sessions.map((session, index) => (
                      <div
                        key={session._id}
                        className="p-3 border rounded-10 d-flex align-items-start justify-content-between"
                        style={{
                          borderColor: index === 0 ? "#EE523C" : "#dee2e6",
                          borderWidth: index === 0 ? "2px" : "1px"
                        }}
                      >
                        <div className="d-flex align-items-start gap-3">
                          <span className="material-symbols-outlined text-muted mt-1">devices</span>
                          <div>
                            <div className="d-flex align-items-center gap-2 mb-1">
                              <span className="fw-semibold fs-sm">
                                {session.browser || t("Unknown browser")}
                              </span>
                              {index === 0 && (
                                <span
                                  className="badge rounded-pill px-2 py-1"
                                  style={{ backgroundColor: "#EE523C", fontSize: "0.7rem" }}
                                >
                                  {t("Current session")}
                                </span>
                              )}
                            </div>
                            <p className="text-muted fs-xs mb-1">
                              <span className="material-symbols-outlined icon-xs align-middle me-1">location_on</span>
                              {t("IP")}: {session.ip || t("Unknown")}
                            </p>
                            <p className="text-muted fs-xs mb-0">
                              <span className="material-symbols-outlined icon-xs align-middle me-1">schedule</span>
                              {new Date(session.createdAt).toLocaleString()}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}

          {activeTab === "connectToApps" && (
            <div className="tab-content-wrapper">
              <div className="p-3 p-lg-4 border border-gray-300 rounded-10 shadow-sm">
                <h3>{t("LinkedIn Helper Webhook")}</h3>

                <div className="form-group mb-4">
                  <label
                    htmlFor="selectList"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Webhook URL")}
                  </label>
                  <div className="d-flex align-items-center gap-2">
                    <input
                      type="text"
                      className="form-control border border-gray-lg-300 rounded-10 shadow-none border border-gray-300"
                      value={copyMessage}
                      readOnly
                    />
                    <Link
                      className="d-flex align-items-center justify-content-center"
                      to="#"
                      onClick={() => {
                        clipboardCopy(copyMessage);
                      }}
                    >
                      <span className="d-block material-symbols-outlined icon-sm">
                        content_copy
                      </span>
                    </Link>
                  </div>
                </div>
              </div>

              {/* Facebook connection section */}
              <div className="mt-4 p-3 p-lg-4 border border-gray-300 rounded-10 shadow-sm">
                <h3>{t("Connect to Facebook for leads")}</h3>

                {/* Add Facebook login button */}
                <div className="action d-flex align-items-center gap-2 mt-3">
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{
                      backgroundColor: "#3b5998",
                      borderColor: "#3b5998",
                    }}
                    onClick={connectWithFacebook}
                  >
                    {t("Connect with Facebook")}
                  </button>
                </div>

                {/* Display Facebook user details if logged in */}
                {fbUser && (
                  <div className="mt-3 p-3 p-lg-4 border border-gray-300 rounded-10 shadow-sm">
                    <h3>{t("Facebook User Details")}</h3>
                    <p>
                      {t("Name")}: {fbUser.name}
                    </p>
                    <p>
                      {t("Email")}: {fbUser.email}
                    </p>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={handleFacebookLogout}
                    >
                      {t("Logout")}
                    </button>
                  </div>
                )}
              </div>

              {/* Add Cognifit User Token */}
              <div className="mt-4 p-3 p-lg-4 border border-gray-300 rounded-10 shadow-sm">
                <h3>{t("Cognifit User Token")}</h3>
                <div className="form-group mb-4">
                  <label
                    htmlFor="cognifitToken"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Token")}
                  </label>
                  <input
                    type="text"
                    id="cognifitToken"
                    className="form-control border border-gray-lg-300 rounded-lg-10 shadow-none border border-gray-300"
                    value={cognifitToken}
                    onChange={(e) => setCognifitToken(e.target.value)}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* save all settings button - fixed footer */}
      <div 
        className="bg-white border-top shadow-lg"
        style={{
          position: 'fixed',
          bottom: 0,
          right: 0,
          left: 0,
          zIndex: 1000,
          padding: '1rem 0'
        }}
      >
        <div className="container-fluid px-lg-5">
          <div className="d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-primary"
              onClick={saveUserHandler}
              disabled={isSaving ? true : false}
              style={{
                cursor: isSaving ? "not-allowed" : "pointer",
              }}
            >
              {t("Save Settings")}
              {isSaving && (
                <div
                  className="mx-2 spinner-border spinner-border-sm"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* ========= popups and modals area =========== */}
      {/* -------- add label modal ------------ */}
      <SaveSettingsSuccessModal afterModalClose={getUserDetails} />

      {/* -------- test mail popup ------------ */}
      <ConversationTestMailPopup
        setShowAlert={setShowAlert}
        setAlertMessage={setAlertMessage}
        setMessageType={setMessageType}
      />

      {/* -------- alert message ------------ */}
      {showAlert && (
        <AlertNotification
          showAlert={showAlert}
          message={alertMessage}
          alertType={messageType}
          onClose={onAlertClose}
        />
      )}

      {/* --------- filter modal ----------- */}
    </div>
  );
};

export default AppUserSettingsBody;
